import { gql } from 'graphql-request';

export const EMPLOYEE_FIELDS = gql`
  fragment EmployeeFields on EmployeeDto {
    employeeId
    rate
    hireDate
    dob
    payPeriod
    mode
    managerProjects {
      projectId
      name
      address
      budget
      siteImage
      startDate
      endDate
      lat
      long
      clientId
    }
    superintendentProjects {
      projectId
      name
      address
      budget
      siteImage
      startDate
      endDate
      lat
      long
      clientId
      projectManagerId
    }
    reviewerProjects {
      projectId
      name
      address
      budget
      siteImage
      startDate
      endDate
      lat
      long
      clientId
    }
    crews {
      crewId
      name
    }
    user {
      firstName
      lastName
      avatar
      email
      userId
      role
      organizationId
      organizationRoleStatus
      organization {
        organizationId
        name
      }
    }
  }
`;

export const getEmployees = gql`
  query getEmployees {
    getEmployees {
      ...EmployeeFields
    }
  }

  ${EMPLOYEE_FIELDS}
`;

export const getEmployeesFiltered = gql`
  query getEmployeesFiltered($filterBy: EmployeeFilterInput) {
    getEmployeesFiltered(filterBy: $filterBy) {
      employees {
        ...EmployeeFields
      }
      total
      page
      limit
    }
  }
  ${EMPLOYEE_FIELDS}
`;

export const createEmployee = gql`
  mutation createEmployee($employee: EmployeeCreateInput!) {
    createEmployee(employee: $employee) {
      ...EmployeeFields
    }
  }
  ${EMPLOYEE_FIELDS}
`;

export const updateEmployee = gql`
  mutation updateEmployee($employee: EmployeeUpdateInput!) {
    updateEmployee(employee: $employee) {
      ...EmployeeFields
    }
  }
  ${EMPLOYEE_FIELDS}
`;

export const deleteEmployee = gql`
  mutation deleteEmployee($id: String!) {
    deleteEmployee(id: $id) {
      affected
      messages
    }
  }
`;

const EmployeesGraphQL = {
  queries: {
    getEmployees,
    getEmployeesFiltered,
  },
  mutations: {
    createEmployee,
    updateEmployee,
    deleteEmployee,
  },
};

export default EmployeesGraphQL;
